import { PromoCode } from 'lib/dto'
import { createContext, useContext } from 'react'

export const PromoCodeContext = createContext<PromoCode | null>(null)

export const usePromoCodeContext = () => useContext(PromoCodeContext)
